export enum PayrollDialogStep {
  TEASER,
  SELECT_PAYROLL_TOOL,
  SPECIFIC_TOOL,
  OTHER_TOOL,
  UNKNOWN_TOOL,
  NO_TOOL,
  SUMMARY,
}

export const payrollDialogStepProgressMap: Record<PayrollDialogStep, number> = {
  [PayrollDialogStep.TEASER]: 0,
  [PayrollDialogStep.SELECT_PAYROLL_TOOL]: 1,
  [PayrollDialogStep.SPECIFIC_TOOL]: 2,
  [PayrollDialogStep.OTHER_TOOL]: 2,
  [PayrollDialogStep.UNKNOWN_TOOL]: 2,
  [PayrollDialogStep.NO_TOOL]: 2,
  [PayrollDialogStep.SUMMARY]: 3,
};
